// Structured data for the 2021 Travel Awards page

export const JUDGES_2021 = [
  { name: 'Mrs. Kathryn Moore', title: 'Founder & Managing Director, Spa Connectors Global' },
  { name: 'Mrs. Jessica Keen', title: 'Australian Tourism Export Council (ATEC)' },
  { name: 'Mrs. Alexandra K. Helou', title: 'World Luxury Hospitality' },
  { name: 'Mr. Michael Cheng, PhD, CHE', title: 'Dean, Chaplin School of Hospitality & Tourism Management, Florida International University' },
  { name: 'Mr. Anthony Melchiorri', title: 'President of Argeo Hospitality' },
  { name: 'Ms. Angela Tunner', title: 'Founder, Editor in Chief, Publisher — EAT LOVE SAVOR®' },
  { name: 'Mrs. Jenny Graham', title: 'Chief Marketing Officer at Quintessentially' },
  { name: 'Mrs. Marla Cimini', title: 'Award-Winning Travel Writer, Editor, Blogger & Consultant' },
  { name: 'Mrs. Beth Santos', title: 'CEO and Founder of "She\'s Wanderful"' },
];

export const CATEGORIES_2021 = [
  {
    id: 'hospitality',
    title: 'Hospitality',
    winner: { name: 'IHG Hotels', url: 'https://ihghotels.com/' },
    finalists: [
      'The Langham Hotels',
      'Jumeirah Hotels',
      'One & Only Resorts',
      'Hilton Hotels',
      'Accor Hotels',
      'Ovolo Hotels',
      'Four Seasons Hotels',
      'Belmond Hotels',
      'Marriott Hotels',
    ],
  },
  {
    id: 'transportation',
    title: 'Transportation',
    winner: { name: 'Emirates Airlines', url: 'https://emirates.com/' },
    finalists: ['Delta', 'Turkish Airlines', 'Qatar Airlines', 'Singapore Airlines'],
  },
  {
    id: 'activities',
    title: 'Activities',
    winner: { name: 'Canada Tourism', url: 'https://canada.travel/' },
    finalists: [
      'Norway Tourism',
      'Australia Tourism',
      'Dubai Tourism',
      'New Zealand Tourism',
      'Singapore Tourism',
    ],
  },
  {
    id: 'government-tourism',
    title: 'Government & Tourism Board',
    winner: { name: 'Maldives', url: 'https://tourism.gov.mv/' },
    finalists: [
      'Hamilton & Waikato, New Zealand',
      'Seychelles',
      'Singapore',
      'Qatar',
      'Western Australia',
      'Dubai, UAE',
    ],
  },
  {
    id: 'worlds-excellence',
    title: "World's Excellence",
    winner: {
      name: "Mr. William 'Chip' Rogers",
      subtitle: 'President & CEO, AHLA (American Hotel & Lodging Association)',
      url: 'https://www.ahla.com/',
    },
    finalists: [
      'Mr. Michael Dominguez — President & CEO, ALHI (Associated Luxury Hotels International)',
      'Mr. Parris Jordan — Chairman and Founder of CHICOS; Managing Director at HVS',
      'Mr. Dr Jeremy Johnson AM — Chair of the Australian Tourism Restart Taskforce',
      'Mr. The Hon. Martin Ferguson AM — Chair of Tourism Accommodation Australia',
      'Mr. Rodrigo Esponda — Managing Director of Los Cabos Tourism Board',
    ],
  },
  {
    id: 'luxury-destination',
    title: "World's Best Luxury Destination",
    winner: { name: 'Maldives', url: 'https://visitmaldives.com/' },
    finalists: [
      'New Zealand',
      'Singapore',
      'Canada',
      'Seychelles',
      'Croatia',
      'Japan',
      'Australia',
      'Greece',
      'French Polynesia',
      'Portugal',
    ],
  },
  {
    id: 'luxury-accommodation',
    title: "World's Best Luxury Accommodation",
    winner: { name: 'Santorini Sky', url: 'https://santorinisky.com/' },
    finalists: [
      'Burj Al Arab Jumeirah, Dubai, UAE',
      'Raffles Hotel, Singapore',
      'Viceroy Resort, Bali, Indonesia',
      'Sura Design Hotel & Suites, Istanbul, Turkey',
      'The Siam Hotel, Bangkok, Thailand',
      'Marina Bay Sands, Singapore',
    ],
  },
  {
    id: 'luxury-air',
    title: "World's Best Luxury Air",
    winner: { name: 'VistaJet', url: 'https://vistajet.com/' },
    finalists: ['Jetex', 'Jetfly', 'JSX', 'Diamonte Jets'],
  },
  {
    id: 'luxury-experience',
    title: "World's Best Luxury Experience",
    winner: { name: 'Los Cabos Tourism', url: 'https://visitloscabos.travel' },
    finalists: [
      'Ireland Tourism',
      'Singapore Tourism',
      'Los Angeles Tourism',
      'Visit Dallas',
      'Australia Tourism',
      'Choose Chicago',
    ],
  },
  {
    id: 'luxury-b2b',
    title: "World's Best Luxury B2B",
    winner: {
      name: 'ALHI (Associated Luxury Hotels International)',
      subtitle: 'United States',
      url: 'https://www.alhi.com/',
    },
    finalists: ['AHLA, United States', 'Compass Edge, Hong Kong', 'Travel-Awards.org'],
  },
];
